module.exports = __webpack_public_path__ + "img/jskids-logo.ca70857b.png";